import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { AccessRequestFolderNotification, AccessRequestArticleNotification } from '../../types'
import { BaseNotificationItem } from '../../BaseNotificationItem'
import Styles from '../../NotificationItem.module.scss'
import { ReactComponent as AccessIcon } from 'assets/icons/lock__16.svg'
import { ReactComponent as AccessGrantIcon } from 'assets/icons/unlocked16.svg'
import { AriaLabelingProps } from '@react-types/shared'
import cx from 'classnames'
import { Button } from 'blaze-ui/Button'

interface Props extends Pick<AriaLabelingProps, 'aria-label'> {
  notification: AccessRequestFolderNotification | AccessRequestArticleNotification
  onClose: () => void
  onClick?: () => void
  path: string
  title: string
}

export const AccessRequestNotification = observer(
  ({ notification, onClose, onClick, path, title, 'aria-label': ariaLabel }: Props) => {
    const { notifications } = useRootStore()
    const subject = notification.subject

    return (
      <BaseNotificationItem
        notification={notification}
        onClose={onClose}
        title={title}
        icon={<AccessIcon role="img" title="Access Icon" className={cx(Styles.icon, Styles.accessIcon)} />}
        path={path}
        onClick={onClick}
        aria-label={ariaLabel}
        secondaryAction={
          <>
            {subject.permission_granted ? (
              <div className={Styles.accessGrantLabel}>
                <AccessGrantIcon /> Granted!
              </div>
            ) : (
              <Button variant="secondary" onPress={() => notifications.markAccessAsGranted(notification.id)}>
                Grant Access
              </Button>
            )}
          </>
        }
      />
    )
  },
)
